<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="userRecycleTable">
      <wt-form-table-list ref="userRecycleTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          {{ data.row.isPublish === 1 ? '正常' : '禁用'}}
        </template>
        <template slot="wtFormTableListButtonsAfter" slot-scope="data">
          <wt-auth v-if="data.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">禁用</el-button>
          </wt-auth>
          <wt-auth v-if="!data.row.isPublish" :hasAnyPremission="form.formCode + ':USABLE'" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toClickAction(data.row)">启用</el-button>
          </wt-auth>
        </template>
        <template slot="tableTopCustom">
          <div class="table-list-desc">当前人员数量 {{form.formResult.total}} 人</div>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_RECYCLE',
        formComponent: {
          view: { type: 'component', componentName: 'UserRecycleViewPage', noRequest: true },
          add: { type: 'component', componentName: 'UserRecycleEditPage', value: 'resetUserRecycleDetailData' },
          edit: { type: 'component', componentName: 'UserRecycleEditPage', noRequest: true },
          list: {
            type: 'default', value: '/modules/userEmployees/userRecycleEmployeesList', params: { updateTimeRange: [] }}
          // delete: { type: 'default', value: '/modules/userEmployees/userEmployeesDelete' }
        },
        formInputsData: [
          { name: '姓名', key: 'name', value: '', type: 'text' },
          { name: '手机号', key: 'phone', value: '', type: 'text' }
          // { name: '社区', key: 'communityId', value: '', type: 'select', data: [] },
          // { name: '站点名称', key: 'siteName', value: '', type: 'text' },
          // { name: '状态', key: 'isPublish', value: '', type: 'select', data: [{ label: '正常', value: 1 }, { label: '禁用', value: 0 }] }
        ],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', className: 'primary', hidden: false, permission: 'ADD' },
          // { name: '删除', key: 'DELETE', action: 'DELETE_LIST', className: 'danger', hidden: false, permission: 'DELETE' },
          { name: '导出Excel', key: 'EXCEL', action: 'EXCEL', hidden: false, url: window.wtConst.BASE_API + '/modules/userEmployees/userEmployeesListImport', fileName: '回收站人员管理', permission: 'EXPORT' }],
        formTableData: [
          { name: '姓名', key: 'name', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '状态', key: 'isPublish', type: 'custom' },
          { name: '账号', key: 'userName', type: 'text' },
          { name: '操作人员', key: 'createUserName', type: 'text' },
          { name: '操作时间', key: 'createTime', type: 'text' }
        ],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonMinWidth: 320, buttonWidth: 320 }
      }
    }
  },
  mounted() {
    // this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserRecycleDetailData', JSON.parse(JSON.stringify(data.row)))
        }
        if (data.item.action === 'EDIT') {
          this.$store.dispatch('setUserRecycleDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    toClickAction(row) {
      const that = this
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认禁用？' : '确认启用？').then(() => {
        that.$api.userEmployees.userRecyclePublish({
          id: row.id
        }).then(res => {
          that.$message({ message: '操作成功', type: 'success' })
          that.$refs.userRecycleTableRef.requestList()
        })
      })
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      this.$api.community.communityNoPageList().then(res => {
        for (const item of res.data) {
          item.label = item.name
          item.value = item.id
        }
        this.form.formInputsData[2].data = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
